import React, { FC, useEffect, useState } from 'react';
import {
  Collapsible,
  CustomLabel,
  FlexContainer,
  InfoIcon,
  LockIcon,
  StatusCircle,
} from '@mindmemobile/mm-shared-global';
import styled from 'styled-components';

type CollapsibleProps = {
  title: string;
  className?: string;
  children?: React.ReactNode;
  isShowInfoIcon?: boolean;
  isShowLockIcon?: boolean;
  isShowStatus?: boolean;
  inActive?: boolean;
  imgSrc?: string;
  collapsibleClassName?: string;
  isOpened?: boolean;
  titleAsNode?: React.ReactNode;
  customCollapsedData?: boolean;
  price?: string;
  onToggle?: (open: boolean) => void;
  enableMobileBehavior?: boolean;
};

const CollapsibleWrapper = styled(FlexContainer)<Partial<CollapsibleProps>>`
  align-items: center;
  i {
    &.fa-chevron-right {
      margin-top: 6px !important;
    }
    &.fa-chevron-down {
      margin-top: 4px !important;
    }
  }
  .custom-collapsed-icon {
    display: inline-block;
    &.fa.fa-regular.charcoal-label {
      margin-top: 6px !important;
    }
  }
`;

const CollapsiblePanel: FC<CollapsibleProps> = ({
  title,
  children,
  className,
  isShowInfoIcon,
  isShowLockIcon,
  imgSrc,
  isShowStatus,
  inActive = false,
  collapsibleClassName,
  isOpened = true,
  onToggle,
  titleAsNode,
  customCollapsedData = false,
  enableMobileBehavior = false,
  price,
  ...props
}) => {
  const mobileValue = useIsMobile();
  const isMobile = enableMobileBehavior ? mobileValue : false;
  const [isOpen, toggleOpen] = useState<boolean>(isMobile ? false : isOpened);

  useEffect(() => {
    toggleOpen(isMobile ? false : isOpened);
  }, [isMobile, isOpened]);

  return (
    <>
      <CollapsibleWrapper className={`label-description-row ${className}`} {...(props as CollapsibleProps)}>
        {isShowStatus && <StatusCircle heightWidth="18px" margin="0px 10px 0px 0px" inActive={inActive} />}
        {imgSrc && <img src={imgSrc} className="collapsed-header-icon" />}
        {/* {!customCollapsedData && (
                    <CustomLabel fontSize="22px" lineHeight="24px" fontWeight="600" className="collapsed-header-label">
                        {title}
                    </CustomLabel>
                )} */}
        {!customCollapsedData && (
          <CustomLabel fontSize="22px" lineHeight="24px" fontWeight="600" className="collapsed-header-label">
            {title}
          </CustomLabel>
        )}
        {isShowInfoIcon && <InfoIcon marginTop="4px" />}
        {isShowLockIcon && <LockIcon marginTop="2px" />}
        {!customCollapsedData && (
          <i
            className={`fa fa-regular ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'} charcoal-label clickable`}
            onClick={() => (onToggle ? onToggle(!isOpen) : toggleOpen(!isOpen))}
          ></i>
        )}
        {customCollapsedData && (
          <FlexContainer justifyContent="space-between" alignItems="flex-start" spacing={30}>
            <div className="flex-auto-grow">
              <FlexContainer alignItems="flex-start">
                {titleAsNode ? (
                  titleAsNode
                ) : (
                  <CustomLabel fontSize="14px" lineHeight="18px" fontWeight="600" className="collapsed-header-label">
                    {title}
                  </CustomLabel>
                )}
                <i
                  className={`fa fa-regular ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'} charcoal-label clickable custom-collapsed-icon`}
                  onClick={() => toggleOpen(!isOpen)}
                ></i>
              </FlexContainer>
            </div>
            {price && parseFloat(price) > 0 && (
              <CustomLabel fontSize="14px" lineHeight="18px" fontWeight="600" className="collapsed-header-label">
                {'$' + price}
              </CustomLabel>
            )}
          </FlexContainer>
        )}
      </CollapsibleWrapper>
      <Collapsible isOpen={isOpen} className={collapsibleClassName}>
        {children}
      </Collapsible>
    </>
  );
};

export default CollapsiblePanel;

export function useIsMobile(breakpoint: number = 768) {
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}
